<template>
<!--paper in proceeding -->
  <section class="body-2 ma-0">
    <span class="pa-0">in Proceedings of the <span class="pa-0"
		v-html="inproceeding.conference_name"></span>, <span
			v-html="inproceeding.place" class="pa-0"></span></span><span 
				v-if="inproceeding.date_from"  class="pa-0">, {{  inproceeding.date_from|dateEU('D.M.YYYY')}}</span><span 
					v-if="inproceeding.date_to" class="pa-0"> - {{  inproceeding.date_to|dateEU('D.M.YYYY')}}</span><span 
						v-if="inproceeding.editors" class="pa-0">, editor(s): <span 
						v-if="inproceeding.editors"  v-html="inproceeding.editors" class="pa-0"></span></span><span 
							v-if="inproceeding.title_book" class="pa-0">, <span 
							v-if="inproceeding.title_book" v-html="inproceeding.title_book" class="pa-0"></span></span><span 
								v-if="inproceeding.publisher" class="pa-0">, <span 
								v-if="inproceeding.publisher" v-html="inproceeding.publisher" class="pa-0"></span></span><span 
									v-if="inproceeding.address_publisher" class="pa-0">, <span 
									v-if="inproceeding.address_publisher" v-html="inproceeding.address_publisher" class="pa-0"></span></span><span 
										v-if="year==2100 || inproceeding.year==2100" class="pa-0">, to appear</span><span 
										v-if="year < 2100" class="pa-0">, {{year}}</span><span 
										v-if="inproceeding.year < 2100" class="pa-0"> {{inproceeding.year}}</span><span 
											v-if="inproceeding.page_from" class="pa-0">, {{  inproceeding.page_from}}</span><span 
												v-if="inproceeding.page_to" class="pa-0"></span><span class="pa-0">-{{  inproceeding.page_to}}</span>
  </section>
</template>
<script>
export default {
  props:['inproceeding','year'],
}
</script>

